import { Injectable, inject } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

export interface IWaitIndicatorService {
  setWaiting(): void;
  setReady(): void;
}

@Injectable({
  providedIn: 'root',
})
export class WaitIndicatorService implements IWaitIndicatorService {
  private spinner = inject(NgxSpinnerService);

  public setWaiting() {
    void this.spinner.show();
  }

  public setReady() {
    void this.spinner.hide();
  }
}
